export default {"src":"/_next/static/media/icon-stats-move-speed.97032515.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};